
     export interface IInvoiceFrameworkScope extends ng.IScope {
         invoiceFrameworkCtrl: ClickOnceDirective;
     }

     export class ClickOnceDirective implements ng.IDirective {
         public restrict = 'A';

         public link = ($scope: IInvoiceFrameworkScope, $elem: ng.IAugmentedJQuery) => {
             var replacementText = $elem.attr('click-once');

             $elem.bind('click', () => {
                 if (replacementText) {
                     $elem.html(replacementText);
                 }
                 $elem.attr('disabled', 'true');
             });
         }

     }